export const HSL_EN_TEMPLATES = {
    common: {
        comma: ", ",
        period: ".",
        bullet: "• ",
        colon: ": ",
        sentenceSeparator: ". "
    },
    brackets: {
        left: "(",
        right: ")"
    },
    labels: {
        lightness: "Lightness",
        hue: "Hue",
        saturation: "Saturation",
        localColor: "Local Color"
    },
    mappings: {
        lightnessLevel: {
            BRIGHT: "bright",
            DARK: "dark",
            NEUTRAL: "neutral"
        },
        dynamicRange: {
            COMPLETE: "complete range",
            PARTIAL: "partial range",
            LIMITED: "limited range"
        },
        skewness: {
            DARK_BIASED: "shadow-biased",
            LIGHT_BIASED: "highlight-biased",
            BALANCED: "balanced distribution"
        },
        kurtosis: {
            CONCENTRATED: "concentrated",
            GENTLE: "gentle spread",
            FLAT: "flat distribution"
        },
        hueTone: {
            RED: "red",
            ORANGE: "orange",
            YELLOW: "yellow",
            YELLOW_GREEN: "yellow-green",
            GREEN: "green",
            CYAN: "cyan",
            CYAN_BLUE: "cyan-blue",
            BLUE: "blue",
            BLUE_PURPLE: "blue-purple",
            PURPLE: "purple",
            MAGENTA: "magenta",
            RED_PURPLE: "red-purple",
            ACHROMATIC: "achromatic"
        },
        hueTemperature: {
            WARM: "warm",
            COOL: "cool",
            MIXED: "mixed warm/cool",
            NEUTRAL: "neutral"
        },
        hueDistribution: {
            CONCENTRATED: "concentrated hue",
            SCATTERED: "scattered hue",
            VERY_SCATTERED: "very scattered hue"
        },
        hueStability: {
            stable: "stable hue",
            shifted: "unstable hue axis, multi-peak tone"
        },
        saturationLevel: {
            STRONG: "strong saturation",
            MODERATE: "moderate saturation",
            WEAK: "weak saturation"
        },
        saturationDistribution: {
            CONCENTRATED: "concentrated saturation",
            SCATTERED: "scattered saturation",
            VERY_SCATTERED: "very scattered saturation"
        },
        saturationStability: {
            stable: "stable saturation",
            highSaturationHighlights: "high saturation in highlights",
            lowSaturationShadows: "low saturation in shadows",
            diverse: "diverse saturation"
        },
        saturationDeviation: {
            DEVIATION_WEAK: "low deviation",
            DEVIATION_MODERATE: "moderate deviation",
            DEVIATION_STRONG: "strong deviation"
        },
        localBalance: {
            both: "both highlights and lowlights stand out",
            highlights: "highlights stand out",
            lowlights: "lowlights stand out",
            neutral: "balanced local color"
        },
        partitions: {
            blacks: "Blacks",
            shadows: "Shadows",
            midtones: "Midtones",
            highlights: "Highlights",
            whites: "Whites"
        }
    },
    rules: {
        lightness: {
            darkComplete: "overall dark with complete range",
            darkLimited: "overall dark with limited range",
            darkPartial: "overall dark with partial range",
            brightComplete: "overall bright with complete range",
            brightLimited: "overall bright with limited range",
            brightPartial: "overall bright with partial range",
            neutralComplete: "overall neutral with complete range",
            neutralLimited: "overall neutral with limited range",
            neutralPartial: "overall neutral with partial range",
            highContrast: "high-contrast character",
            lowKey: "low-key character",
            highKey: "high-key character",
            richShadowDetail: "rich shadow detail",
            wellControlledHighlight: "well-controlled highlights",
            richShadow: "rich shadow layers",
            concentratedShadow: "concentrated shadows",
            richHighlight: "rich highlight layers",
            brightHighlight: "bright highlights",
            compressedMidtone: "compressed midtones",
            balancedMidtone: "balanced midtones"
        },
        hue: {
            OVERALL_HUE_CONSISTENCY: "hue stays consistent across partitions",
            OVERALL_HUE_VARIATIONS: "some partitions differ from overall hue",
            SHADOW_HIGHLIGHT_HUE_CONTRAST: "warm/cool contrast between shadows and highlights"
        },
        saturation: {
            OVERALL_SATURATION_CONSISTENCY: "saturation stays consistent across partitions",
            OVERALL_SATURATION_VARIATIONS: "some partitions differ strongly in saturation",
            SHADOW_HIGHLIGHT_SATURATION_CONTRAST: "saturation contrast between shadows and highlights"
        }
    },
    noData: "No valid data, analysis skipped."
};
